//Multiregion (Language & Timezone)

export const DEFAULT_LANGUAGE = 'en-us';

export const DATE_FORMATS = {
    en: 'MM/dd/yyyy',
    es: 'dd/MM/yyyy',
    pt: 'dd/MM/yyyy',
};

export const SUPPORTED_LANGUAGES = {
    en: 'en-us',
    es: 'es-mx',
    pt: 'pt-br',
};

export const FROALA_LANGUAGE_CODE_EQUIVALENCE = {
    en: 'en',
    es: 'es',
    pt: 'pt_br',
};

export const ACADEMY_LANGUAGE_CODE_EQUIVALENCE = {
    en: 'en',
    es: 'es',
    pt: 'pt-BR',
};
